<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">停賣列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
              <!-- <select class="form-control h-38" v-model="brandSelect">
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select> -->
              <multiselect
                v-model="brandSelect"
                :options="brandBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 品牌 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
              >
              </multiselect>
            </div>
            <div class="form-group" v-if="brandSelect.value !== 99 && brandSelect.value !== '99' && storeBrief.length > 1">
              <!-- <select class="form-control h-38" v-model="storeSelect">
                <option v-for="store in storeBrief" :value="store.value">
                  {{store.label}}
                </option>
              </select> -->
              <multiselect
                v-model="storeSelect"
                :options="storeBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 門市 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
              >
              </multiselect>
            </div>
            <div class="form-group pull-right">
              <span
                v-if="$route.name !== 'storeInfo' &&
                  storeSelect.value === 999999 && roleType !== 10"
              >
                <button
                  class="btn btn-default btn-table-title"
                  @click="goPage"
                >
                  查看批次紀錄
                </button>
              </span>
              <span v-if="brandSelect.value !== 99 && brandSelect.value !== '99' && storeSelect.value !== 999999">
                <button class="btn btn-default btn-table-title" @click="goPage">
                  查看歷程紀錄
                </button>
              </span>
            </div>

            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">菜單 (ID)</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">備註</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="menuList.length === 0">
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="menuList.length > 0">
                    <tr class="even" role="row" v-for="(menu, index) in menuList">
                      <td class="sorting_1">{{index + 1}}</td>
                      <td>{{menu.name}} ({{menu.id}})</td>
                      <td>{{menu.remark}}</td>
                      <td v-if="storeSelect.value && storeSelect.value !== 999999">
                        <router-link :to="'/disProduct/' + menu.brand_id + '/' + menu.id + '/' + storeSelect.value + '/forever'">
                          <button class="btn btn-danger"><i class="fa fa-pencil"></i>&nbsp;&nbsp;永久停賣</button>
                        </router-link>
                        <router-link :to="'/disProduct/' + menu.brand_id + '/' + menu.id + '/' + storeSelect.value + '/daily'">
                          <button class="btn btn-success"><i class="fa fa-pencil"></i>&nbsp;&nbsp;當日停賣</button>
                        </router-link>
                      </td>
                      <td v-else>
                        <button class="btn btn-default" data-toggle="modal" data-target="#storesModal" @click="clickCurrent(menu)"><i class="fa fa-home"></i></button>&nbsp;
                        <router-link :to="'/disProduct/' + menu.brand_id + '/' + menu.id">
                          <button class="btn btn-danger"><img class="full-whdth" src="../../../assets/icon/ban.svg" alt="point_icon">&nbsp;&nbsp;多店停賣</button>
                        </router-link>
                        <router-link :to="'/reDisProduct/' + menu.brand_id + '/' + menu.id">
                          <button class="btn btn-success"><img class="full-whdth" src="../../../assets/icon/relieveSus.svg" alt="point_icon">&nbsp;&nbsp;多店解除停賣</button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="storesModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">"{{current.name}}"使用門市</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 p-x-0">
                <div class="inline-block" style="margin: 2.5px 5px 2.5px 0px;" v-for="store in current.store_list">
                  <label class="label label-primary">{{store.name}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import disItem from './Temp/DisItemTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: ''
      },
      storeSelect: {
        value: 999999,
        label: '==門市=='
      },
      menuList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      isLoading: true
    }
  },
  mounted () {
  },
  components: {
    'dis-item-table': disItem
  },
  methods: {
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
            self.brandBrief.push(obj)
            if (i === 0) self.brandSelect = obj
          }
        }
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | DisItemTable')
      this.storeBrief = [{label: '==門市==', value: 999999}]
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj
            } else if (i === 0) self.storeSelect.value = 999999
          }
          if (!sList.length) {
            self.menuList = []
            self.total = 0
          }
          self.getOnlineMenu()
        }
      })
    },
    getOnlineMenu () {
      this.isLoading = true
      var self = this
      var url = '/onlineMenu/list?page=' + this.tableIndex + '&size=' + this.count + '&brand_id=' + this.brandSelect.value
      if (this.storeSelect.value !== 999999) url = url + '&store_id=' + this.storeSelect.value
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.menuList = response.data.menu_list
          self.total = response.data.total
          self.isLoading = false
        }
      })
    },
    clickCurrent (menu) {
      this.current = menu
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getOnlineMenu()
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    goPage () {
      if (this.storeSelect.value !== 999999) {
        this.$router.push(`/disItemTable/${this.brandSelect.value}/${this.storeSelect.value}`)
        // 門市: 歷程記錄
      } else if (this.brandSelect.value && this.storeSelect.value === 999999) {
        // 品牌: 批次紀錄
        this.$router.push(`/disItemTable/${this.brandSelect.value}`)
      }
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    this.getBrandBrief()
  },
  watch: {
    'brandSelect.value' () {
      this.storeSelect = {
        value: 999999,
        label: '==門市=='
      }
      this.getStoreBrief(this.brandSelect.value)
    },
    'storeSelect.value' () {
      this.getOnlineMenu()
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (max-width: 767px) {
  .pull-right {
    float: none !important;
    position: relative;
    z-index: 1;
  }
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
.box-body .form-group .multiselect {
  position: relative;
  z-index: 60;
}
.box-body .form-group .multiselect.multiselect--active {
  z-index: 100;
}
.multiselect__content-wrapper {
  z-index: 100 !important;
}
.box-body .form-group.pull-right {
  position: relative;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// DisItemTable.vue?e03babbc